import React from 'react'
import { Link, graphql, StaticQuery } from 'gatsby'
import Image from 'gatsby-image'

import styles from './navbar.module.css'
import externalIcon from '../images/external.svg'

const Navbar = () => (
  <StaticQuery
    query={graphql`
      query NavbarQuery {
        file(relativePath: { eq: "logo.png" }) {
          childImageSharp {
            fixed(height: 25) {
              ...GatsbyImageSharpFixed_noBase64
            }
          }
        }
      }
    `}
    render={data => (
      <header className={styles.header}>
        <div>
          <Link to="/" className={styles.link}>
            <Image fixed={data.file.childImageSharp.fixed} />
          </Link>
        </div>
        <div>
          <ul className={styles.list}>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://kabirgoel.com/notes/unslant-motivation/"
              >
                Motivation{' '}
                <img
                  className={styles.external}
                  src={externalIcon}
                  alt="External link"
                />
              </a>
            </li>
          </ul>
        </div>
      </header>
    )}
  />
)

export default Navbar
